module.exports = __webpack_public_path__ + "static/gallery-4-b5df40e0c7c606f4ea2970a13650d3f0.png";